import { gql } from '@apollo/client';

export const GET_CHEAPEST_HOTELS_QUERY = gql`
    subscription GetCheapestStayByHotel($request: CheapestStayByHotelRequestQL!) {
        getCheapestStayByHotel(request: $request) {
            placeCode
            date
            boardBasis
            isRefundable
            prices {
                totalPrice {
                    amount
                    currency
                    currencySymbol
                }
                pricePerPerson {
                    amount
                    currency
                    currencySymbol
                }
            }
            roomStays {
                description
                boardBasis
                roomCode
                roomTypeId
                pax {
                    age
                }
                cancellationPolicies {
                    fromDate
                    fromDateIso
                    amount {
                        amount
                        currency
                        currencySymbol
                    }
                }
                price {
                    amount
                    currency
                    currencySymbol
                }
            }
        }
    }
`;

export const SEARCH_ITINERARIES_SUBSCRIPTION = gql(`
  subscription searchItineraries($recipe: RecipeQL!) {
    searchRecipeByItinerary(recipe: $recipe) {
      itineraryKey
      result {
        ... on HotelIngredientResponseQL {
          suggested {
            placeCode: hotelCode
            date
            boardBasisOptions {
              boardBasis
            }
            isRefundable
            prices {
              totalPrice {
                amount
                currency
                currencySymbol
              }
              pricePerPerson {
                amount
                currency
                currencySymbol
              }
            }
            roomStays {
              description
              boardBasis
              roomCode
              roomTypeId
              pax {
                age
              }
              cancellationPolicies {
                fromDate
                fromDateIso
                amount {
                  amount
                  currency
                  currencySymbol
                }
              }
              price {
                amount
                currency
                currencySymbol
              }
            }
          }
          suggestions{
            placeCode: hotelCode
            date
            boardBasisOptions {
              boardBasis
            }
            isRefundable
            prices {
              totalPrice {
                amount
                currency
                currencySymbol
              }
              pricePerPerson {
                amount
                currency
                currencySymbol
              }
            }
            roomStays {
              description
              boardBasis
              roomCode
              roomTypeId
              pax {
                age
              }
              cancellationPolicies {
                fromDate
                fromDateIso
                amount {
                  amount
                  currency
                  currencySymbol
                }
              }
              price {
                amount
                currency
                currencySymbol
              }
            }
          }
        }
        __typename
      }
    }
  }
`);
